import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

function EntryBox({
  competitionSlug, path, id, entryName, entrySlug, authorName, imageUrl,
}) {
  return (
    <div className="col-12 col-sm-6 col-md-3 infinite-gallery__item-container">
      <Link
        to={{ pathname: `/${path}/${id}/${entrySlug}` }}
        params={{ competitionSlug }}
        className="infinite-gallery__item"
      >
        <div className="infinite-gallery__item-shadow" />
        <div className="infinite-gallery__item-overlay">
          <h2 className="infinite-gallery__item-title">{entryName}</h2>
          <h3 className="infinite-gallery__item-author">{authorName}</h3>
        </div>
        <img src={imageUrl} alt={entryName} />
      </Link>
    </div>
  )
}

EntryBox.propTypes = {
  id: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  entryName: PropTypes.string.isRequired,
  entrySlug: PropTypes.string.isRequired,
  authorName: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
}

export default EntryBox
